/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ConfigCreateEvent } from './ConfigCreateEvent';
import {
    ConfigCreateEventFromJSON,
    ConfigCreateEventFromJSONTyped,
    ConfigCreateEventToJSON,
} from './ConfigCreateEvent';
import type { ConfigDeleteEvent } from './ConfigDeleteEvent';
import {
    ConfigDeleteEventFromJSON,
    ConfigDeleteEventFromJSONTyped,
    ConfigDeleteEventToJSON,
} from './ConfigDeleteEvent';
import type { ConfigUpdateEvent } from './ConfigUpdateEvent';
import {
    ConfigUpdateEventFromJSON,
    ConfigUpdateEventFromJSONTyped,
    ConfigUpdateEventToJSON,
} from './ConfigUpdateEvent';
import type { SubscribeProviderOptions } from './SubscribeProviderOptions';
import {
    SubscribeProviderOptionsFromJSON,
    SubscribeProviderOptionsFromJSONTyped,
    SubscribeProviderOptionsToJSON,
} from './SubscribeProviderOptions';

/**
 * 
 * @export
 * @interface BaseSubscribeConfigObject
 */
export interface BaseSubscribeConfigObject {
    /**
     * Whether to inherit fields and mappings from the read config. When omitted, the integration's `inheritFieldsAndMapping` from amp.yaml is used. If true, fields and mappings come from the matching read config object, and `selectedFields` and `selectedFieldMappings` cannot be used. If false, nothing is inherited from the read config, and the object's own `selectedFields` and `selectedFieldMappings` are used instead; at least one of them must be set.
     * @type {boolean}
     * @memberof BaseSubscribeConfigObject
     */
    inheritFieldsAndMappings?: boolean | null;
    /**
     * The name of the object to subscribe to.
     * @type {string}
     * @memberof BaseSubscribeConfigObject
     */
    objectName: string;
    /**
     * The name of the destination that the result should be sent to.
     * @type {string}
     * @memberof BaseSubscribeConfigObject
     */
    destination: string;
    /**
     * This is a map of field names to booleans indicating whether they should be included in subscription events. Only used when `inheritFieldsAndMappings` is false; otherwise fields are inherited from the read config. If a field is already included in `selectedFieldMappings`, it does not need to be included here.
     * @type {{ [key: string]: boolean; }}
     * @memberof BaseSubscribeConfigObject
     */
    selectedFields?: { [key: string]: boolean; };
    /**
     * This is a map of mapToNames to field names. (A mapTo name is the name the builder wants to map a field to when it lands in their destination.) Only used when `inheritFieldsAndMappings` is false; otherwise mappings are inherited from the read config.
     * @type {{ [key: string]: string; }}
     * @memberof BaseSubscribeConfigObject
     */
    selectedFieldMappings?: { [key: string]: string; };
    /**
     * 
     * @type {ConfigCreateEvent}
     * @memberof BaseSubscribeConfigObject
     */
    createEvent?: ConfigCreateEvent;
    /**
     * 
     * @type {ConfigUpdateEvent}
     * @memberof BaseSubscribeConfigObject
     */
    updateEvent?: ConfigUpdateEvent;
    /**
     * 
     * @type {ConfigDeleteEvent}
     * @memberof BaseSubscribeConfigObject
     */
    deleteEvent?: ConfigDeleteEvent;
    /**
     * 
     * @type {Array<string>}
     * @memberof BaseSubscribeConfigObject
     */
    otherEvents?: Array<string>;
    /**
     * 
     * @type {SubscribeProviderOptions}
     * @memberof BaseSubscribeConfigObject
     */
    providerOptions?: SubscribeProviderOptions;
}

/**
 * Check if a given object implements the BaseSubscribeConfigObject interface.
 */
export function instanceOfBaseSubscribeConfigObject(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "objectName" in value;
    isInstance = isInstance && "destination" in value;

    return isInstance;
}

export function BaseSubscribeConfigObjectFromJSON(json: any): BaseSubscribeConfigObject {
    return BaseSubscribeConfigObjectFromJSONTyped(json, false);
}

export function BaseSubscribeConfigObjectFromJSONTyped(json: any, ignoreDiscriminator: boolean): BaseSubscribeConfigObject {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'inheritFieldsAndMappings': !exists(json, 'inheritFieldsAndMappings') ? undefined : json['inheritFieldsAndMappings'],
        'objectName': json['objectName'],
        'destination': json['destination'],
        'selectedFields': !exists(json, 'selectedFields') ? undefined : json['selectedFields'],
        'selectedFieldMappings': !exists(json, 'selectedFieldMappings') ? undefined : json['selectedFieldMappings'],
        'createEvent': !exists(json, 'createEvent') ? undefined : ConfigCreateEventFromJSON(json['createEvent']),
        'updateEvent': !exists(json, 'updateEvent') ? undefined : ConfigUpdateEventFromJSON(json['updateEvent']),
        'deleteEvent': !exists(json, 'deleteEvent') ? undefined : ConfigDeleteEventFromJSON(json['deleteEvent']),
        'otherEvents': !exists(json, 'otherEvents') ? undefined : json['otherEvents'],
        'providerOptions': !exists(json, 'providerOptions') ? undefined : SubscribeProviderOptionsFromJSON(json['providerOptions']),
    };
}

export function BaseSubscribeConfigObjectToJSON(value?: BaseSubscribeConfigObject | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'inheritFieldsAndMappings': value.inheritFieldsAndMappings,
        'objectName': value.objectName,
        'destination': value.destination,
        'selectedFields': value.selectedFields,
        'selectedFieldMappings': value.selectedFieldMappings,
        'createEvent': ConfigCreateEventToJSON(value.createEvent),
        'updateEvent': ConfigUpdateEventToJSON(value.updateEvent),
        'deleteEvent': ConfigDeleteEventToJSON(value.deleteEvent),
        'otherEvents': value.otherEvents,
        'providerOptions': SubscribeProviderOptionsToJSON(value.providerOptions),
    };
}

